/* eslint-disable camelcase */
import { Accordion, AccordionDetails, AccordionSummary, Button, Divider, Grid, Icon, Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { setActions } from 'components/ActionUtil'
import Card from 'components/card/Card'
import CartographyPanel from 'components/map/CartographyPanel'
import HomeAction from 'home/actions/HomeAction'
import { compact, groupBy, omit, orderBy, uniq, uniqWith } from 'lodash'
import VariousMaterielAction from 'materiel/components/variousMateriel/actions/VariousMaterielAction'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import ContributorAction from 'referencial/components/contributor/actions/ContributorAction'
import i18n from 'simple-react-i18n'
import EvolVolumesChartPanel from 'survey/components/panels/EvolVolumesChartPanel'
import { getCampaignPeriod, getCampaignYear, getDate } from 'utils/DateUtil'
import { hasValue } from 'utils/NumberUtil'
import { formatMilliers, getI18nTitleData } from 'utils/StringUtil'
import AgriAction from '../../agriAdministration/actions/AgriAction'
import AddConsoModal from './modal/AddConsoModal'
import MatEventModal from './modal/MatEventModal'
import { useParams } from 'react-router'
import useApplicationSetting, { intParser } from 'utils/customHook/useApplicationSetting'
import { POINT_STATUS_EXPLOITATION, RESTRICTIONS_TYPES, SITU_POINT_PUMP, SITU_PUMP_COUNTER, STATIC_USAGES_TYPES, SURVEY_TYPES } from 'agriAdministration/constants/AgriConstants'
import { People, Warning } from '@mui/icons-material'
import ManagementUnitAction from '../../referencial/components/managementUnit/actions/ManagementUnitAction'
import { getPointEntrySettings } from '../utils/AgriUtils'

const GridItem = styled(Grid)({
    borderBottom: '1px solid grey',
    padding: '8px 16px',
    cursor: 'pointer',
    backgroundColor: 'white',
})

const Element = styled(Grid)({
    padding: '4px !important',
    textAlign: 'center',
})

const useStyles = makeStyles({
    textLeft: {
        textAlign: 'end',
    },
    textRight: {
        textAlign: 'end',
        fontWeight: 'bold',
    },
})

const TYPE_ESTIM = 1
const TYPE_INDEX = 2

const ExploitationConsumptionsApp = () => {
    const { id } = useParams()

    const [exploitationId] = useState(id)
    const startDateCampaign = useApplicationSetting('startDateCampaign')
    const [year, setYear] = useState(getCampaignYear(moment(), startDateCampaign))
    const [numberOfLines, setNumberOfLines] = useState(10)
    const [openModalEvent, setOpenModalEvent] = useState(false)
    const [selectedEvent, setSelectedEvent] = useState()
    const [paramsModalConso, setParamsModalConso] = useState({ open: false, selectedMaterial: undefined, consoType: undefined })
    const [realConso, setRealConso] = useState()
    const [lowWaterConso, setLowWaterConso] = useState()
    const [declarationReal, setDeclarationReal] = useState()
    const classes = useStyles()

    const typeRestriction = useApplicationSetting('agriTypeRestriction', setting => setting ? parseInt(setting) : RESTRICTIONS_TYPES.MANAGEMENT_UNITS)
    const entryFrequency = useApplicationSetting('entryFrequency', intParser)
    const entryFrequencyDay = useApplicationSetting('entryFrequencyDay', intParser)
    const entryRangeDaysBefore = useApplicationSetting('entryRangeDaysBefore', intParser)
    const entryRangeDaysAfter = useApplicationSetting('entryRangeDaysAfter', intParser)

    const {
        exploitation,
        installationsWithGeo,
        citiesIndex,
        contributor,
        contributorsIndex,
        variousMateriels,
        exploitationVolumes,
        matEventsExploitation,
        matEventsTypes,
        declarationsExploitation,
        declaration,
        usages,
        accountUser,
        restrictions,
        droughtSectorsRestrictions,
        managementUnitsRestrictions,
    } = useSelector(store => ({
        exploitation: store.AgriReducer.exploitation,
        exploitationVolumes: store.AgriReducer.exploitationVolumes,
        declarationsExploitation: store.AgriReducer.declarationsExploitation,
        declaration: store.AgriReducer.declaration,
        usages: store.UsageReducer.usages,
        restrictions: store.AgriReducer.restrictions,
        droughtSectorsRestrictions: store.AgriReducer.droughtSectorsRestrictions,
        managementUnitsRestrictions: store.ManagementUnitReducer.managementUnitsRestrictions,
        installationsWithGeo: store.InstallationReducer.installationsWithGeo,
        citiesIndex: store.CityReducer.citiesIndex,
        contributor: store.ContributorReducer.contributor,
        contributorsIndex: store.ContributorReducer.contributorsIndex,
        variousMateriels: store.VariousMaterielReducer.variousMateriels,
        matEventsExploitation: store.VariousMaterielReducer.matEventsExploitation,
        matEventsTypes: store.VariousMaterielReducer.matEventsTypes,
        accountUser: store.AccountReducer.accountUser,
    }), shallowEqual)

    const isConsult = useMemo(() => accountUser.consultant === '1', [accountUser])

    const dispatch = useDispatch()

    const getMarker = (stateCode) => {
        switch (stateCode) {
            case 1:
                return 'pictures/markers/map_qualite_green.png'
            case 2:
                return 'pictures/markers/map_qualite_yellow.png'
            case 3:
                return 'pictures/markers/map_qualite_red.png'
            case 4:
                return 'pictures/markers/map_qualite_white.png'
            default:
                return 'pictures/markers/map_qualite_green.png'
        }
    }

    const exploitationPoints = useMemo(() => compact(exploitation.link_samplings.filter((p) => !p.endDate || p.endDate > moment().valueOf()).map((linkPoint) => {
        const point = installationsWithGeo.find((i) => i.id === linkPoint.idInstallation)
        return point ? {
            ...point,
            startDate: linkPoint.startDate,
            endDate: linkPoint.endDate,
            stateCode: linkPoint.stateCode,
            typeName: 'other',
            markerIcon: getMarker(linkPoint.stateCode),
        } : undefined
    })), [exploitation, installationsWithGeo])

    const exploitationPointsHisto = useMemo(() => compact(exploitation.link_samplings.filter((p) => p.endDate && p.endDate <= moment().valueOf()).map((linkPoint) => {
        const point = installationsWithGeo.find((i) => i.id === linkPoint.idInstallation)
        return point ? {
            ...point,
            startDate: linkPoint.startDate,
            endDate: linkPoint.endDate,
            stateCode: linkPoint.stateCode,
            histo: true,
        } : undefined
    })), [exploitation, installationsWithGeo])

    const [pointSelected, setPointSelected] = useState(() => {
        if (exploitationPoints.length === 1) {
            return exploitationPoints[0]
        }
        return undefined
    })

    useEffect(() => {
        if (exploitation?.idExploitation) {
            dispatch(VariousMaterielAction.fetchMatEventsByExploitation(exploitation.idExploitation))
            dispatch(AgriAction.fetchDeclarationsByExploitationId(exploitation.idExploitation))
        }
    }, [exploitation])

    useEffect(() => {
        dispatch(AgriAction.fetchRestrictions())
        if (typeRestriction === RESTRICTIONS_TYPES.DROUGHT_SECTORS) {
            dispatch(AgriAction.fetchDroughtSectorsRestrictions())
        } else {
            dispatch(ManagementUnitAction.fetchManagementUnitsRestrictions())
        }
    }, [typeRestriction])

    const entrySettings = useMemo(() => getPointEntrySettings({
        point: pointSelected,
        restrictions,
        managementUnitsRestrictions,
        droughtSectorsRestrictions,
        typeRestriction,
        globalSettings: { entryFrequency, entryFrequencyDay, entryRangeDaysBefore, entryRangeDaysAfter },
    }), [pointSelected, restrictions, managementUnitsRestrictions, droughtSectorsRestrictions, typeRestriction,
        entryFrequency, entryFrequencyDay, entryRangeDaysBefore, entryRangeDaysAfter])

    useEffect(() => {
        if (contributor?.id !== exploitation?.operatorCode) {
            dispatch(ContributorAction.fetchContributor(exploitation?.operatorCode))
        }
        dispatch(HomeAction.setTitle([
            {
                title: i18n.folders,
                href: 'dossiers',
            },
            {
                title: `${contributor.name || ''} ${exploitation.codification ? `[${exploitation.codification}]` : ''}`,
                href: `dossiers/${exploitation.idExploitation}/dashboard`,
            },
            {
                title: i18n.consos,
                href: `dossiers/${exploitation.idExploitation}/consumptions`,
            },
        ]))
        if (exploitation?.idExploitation !== parseInt(exploitationId)) {
            dispatch(AgriAction.fetchExploitation(exploitationId))
        }
    }, [exploitationId, exploitation, contributor, pointSelected])

    useEffect(() => {
        dispatch(AgriAction.fetchExploitationVolumes(exploitationId))
    }, [exploitationId])

    useEffect(() => {
        if (variousMateriels?.length) {
            setActions({
                export: () => {
                    const chronicles = exploitation?.link_chronicles
                    const dataFormatted = chronicles?.length ? compact(orderBy(chronicles, ['idMat', 'measureDate'], ['asc', 'desc']).map((c) => {
                        const mat = variousMateriels.find((m) => m.id === c.idMat) || {}
                        if (hasValue(mat.administrator) && mat.administrator !== exploitation.operatorCode) {
                            return undefined
                        }
                        return {
                            matCode: mat.reference || mat.serialNumber || `[${mat.id}]`,
                            measureDate: getDate(c.measureDate),
                            endDate: getDate(c.endDate),
                            value: `${formatMilliers(c.value) || 0} ${c.measureType === 1 ? 'm3' : ''}`,
                        }
                    })) : []
                    if (dataFormatted.length) {
                        dataFormatted[0].headers = ['matCode', 'measureDate', 'endDate', 'value']
                    }
                    return {
                        data: dataFormatted,
                        exportType: 'xlsx',
                        titleFile: `${exploitation.codification} - ${i18n.consos}`,
                    }
                },
            })
        }
    }, [exploitation, variousMateriels])

    const pointsUsed = useMemo(() => exploitationPoints.filter(({ stateCode }) => stateCode === POINT_STATUS_EXPLOITATION.USED), [exploitationPoints])
    const pointsNotUsed = useMemo(() => exploitationPoints.filter(({ stateCode }) => stateCode === POINT_STATUS_EXPLOITATION.NOT_USED), [exploitationPoints])
    const pointsAbandonned = useMemo(() => exploitationPoints.filter(({ stateCode }) => stateCode === POINT_STATUS_EXPLOITATION.CLOSED), [exploitationPoints])

    const getMateriels = (pointId, showShared = false) => {
        const pointPumps = exploitation.link_materiel.filter((m) => m.siteType === SITU_POINT_PUMP && m.siteCode === pointId)
        const pointCounters = exploitation.link_materiel.filter((m) => m.siteType === SITU_PUMP_COUNTER && pointPumps.some(({ idVarious }) => idVarious === m.siteCode))
        const pumpsIds = pointPumps.map(({ idVarious }) => idVarious)
        const countersIds = pointCounters.map(({ idVarious }) => idVarious)
        const materiels = variousMateriels.filter((m) => [...pumpsIds, ...countersIds].includes(m.id) && (!hasValue(m.administrator) || (m.administrator === exploitation.operatorCode) || (showShared && m.isShared)))
        return { pumpsIds, countersIds, materiels }
    }

    const getLastChronicle = (point) => {
        const { materiels } = getMateriels(point.id, true)
        const pointChronicles = exploitation.link_chronicles.filter(({ idMat, measureDate }) => materiels.map(m => m.id).includes(idMat) &&
            (!point.startDate || measureDate >= point.startDate) &&
            (!point.endDate || measureDate < point.endDate),
        )
        const lastChronicle = pointChronicles.length ? pointChronicles.reduce((max, chronique) => (max.measureDate > chronique.measureDate) ? max : chronique) : undefined
        if (lastChronicle) {
            const matFound = materiels.find((m) => m.id === lastChronicle.idMat) || {}
            return (
                <>
                    {lastChronicle.measureType === 1 ? (
                        <>
                            <b className='bold'>{matFound.reference || i18n.unknown}</b>
                            <span className='italic-label'>{` - ${getDate(lastChronicle.measureDate)} -> ${getDate(lastChronicle.endDate)} : ${formatMilliers(lastChronicle.value) || 0} m3`}</span>
                        </>
                    ) : (
                        <>
                            <b className='bold'>{matFound.reference || i18n.unknown}</b>
                            <span className='italic-label'>{` - ${getDate(lastChronicle.measureDate)} : ${formatMilliers(lastChronicle.value) || 0}`}</span>
                        </>
                    )}
                </>
            )
        }
        return <span>{i18n.noConsumptionIndicated}</span>
    }

    const editModalIndex = (type, smId) => {
        setParamsModalConso({ selectedMaterial: smId, consoType: type, open: true })
    }

    const getEvolValue = (type, chronicles, chronicle, index) => {
        if (type === TYPE_INDEX) {
            return chronicle.value - chronicles[index + 1].value
        }
        return Math.round(chronicles.slice(index).reduce((acc, d) => acc + d.value, 0))
    }

    const getChroniclesByType = (chroniclesByType, type, materiel, readingCoefficient = 1, shared) => {
        const orderedChronicles = orderBy(chroniclesByType, ['measureDate', 'endDate', 'value'], ['desc', 'desc', 'desc'])
        const currentChronicles = orderedChronicles.filter((c) => getCampaignYear(moment(c.measureDate), startDateCampaign) >= year)
        const pastChronicles = orderedChronicles.filter((c) => !c.event && getCampaignYear(moment(c.measureDate), startDateCampaign) < year)
        if (chroniclesByType?.length) {
            const props = {
                onClick: !pointSelected.histo && !isConsult && !shared ? () => editModalIndex(type, materiel.id) : () => {},
            }
            return (
                <>
                    <Element className='italic-label' size={3} {...props}>
                        {type === TYPE_ESTIM ? i18n.startDate : i18n.statementDate}
                    </Element>
                    <Element className='italic-label' size={3} {...props}>
                        {type === TYPE_ESTIM ? i18n.endDate : ''}
                    </Element>
                    <Element className='italic-label' size={3} {...props}>
                        {type === TYPE_ESTIM ? i18n.estimateM3 : i18n.index}
                    </Element>
                    <Element className='italic-label' size={3}>
                        {type === TYPE_ESTIM ? i18n.stack : i18n.evolution}
                    </Element>
                    {currentChronicles.slice(0, numberOfLines).map((chronicle, i) => {
                        if (chronicle.event) {
                            const onClickEvent = {
                                onClick: !pointSelected.histo && !isConsult && !shared ? () => {
                                    setSelectedEvent(chronicle)
                                    setOpenModalEvent(true)
                                } : () => {},
                            }
                            return (
                                <Fragment key={`event_${chronicle.id}`}>
                                    <Element size={3} {...onClickEvent}>
                                        {getDate(chronicle.measureDate)}
                                    </Element>
                                    <Element size={3} {...onClickEvent}>
                                        {(matEventsTypes.find(t => t.id === chronicle.idType) || {}).name || ''}
                                    </Element>
                                    <Element size={3} {...onClickEvent} >
                                        <Tooltip title={chronicle.comment}>
                                            <Warning />
                                        </Tooltip>
                                    </Element>
                                    <Element size='grow' {...onClickEvent} />
                                </Fragment>
                            )
                        }
                        const valueEvol = i !== currentChronicles.length - 1 ? getEvolValue(type, currentChronicles, chronicle, i) : undefined
                        return (
                            <Fragment key={chronicle.idChronicle}>
                                <Element size={3} {...props}>
                                    {getDate(chronicle.measureDate)}
                                </Element>
                                <Element size={3} {...props}>
                                    {chronicle.endDate ? getDate(chronicle.endDate) : ''}
                                </Element>
                                <Element size={3} {...props}>
                                    {`${formatMilliers(chronicle.value) || 0}${type === TYPE_ESTIM ? ' m3' : ''}`}
                                </Element>
                                <Element size={3} sx={ valueEvol < 0 ? { color: 'orange' } : {}}>
                                    {hasValue(valueEvol) ? ` ${valueEvol < 0 ? '-' : '+'} ${formatMilliers(Math.abs((valueEvol) * readingCoefficient))} m3` : ''}
                                </Element>
                            </Fragment>
                        )
                    })}
                    {pastChronicles.length > 0 && <Element size={12}>...</Element>}
                    {pastChronicles[0] && (
                        <>
                            <Element size={3} {...props}>
                                {getDate(pastChronicles[0].measureDate)}
                            </Element>
                            <Element size={3} {...props}>
                                {pastChronicles[0].endDate ? getDate(pastChronicles[0].endDate) : ''}
                            </Element>
                            <Element size={3} {...props}>
                                {`${formatMilliers(pastChronicles[0].value) || 0}${type === TYPE_ESTIM ? ' m3' : ''}`}
                            </Element>
                            <Element size={3}>
                                {getCampaignYear(moment(pastChronicles[0].measureDate), startDateCampaign) !== year && <Icon>access_time</Icon>}
                            </Element>
                        </>
                    )}
                    <Element size={11}>
                        <Divider />
                    </Element>
                </>
            )
        }
        return undefined
    }

    const getChronicles = (groupedChronicles) => (groupedChronicles.map((chronicles) => {
        const variousMat = variousMateriels.find((mat) => mat.id === chronicles[0].idMat) || {}
        const shared = hasValue(variousMat.administrator) && (variousMat.administrator !== exploitation.operatorCode) && variousMat.isShared
        if (!hasValue(variousMat.administrator) || (variousMat.administrator === exploitation.operatorCode) || variousMat.isShared) {
            const indexChronicles = chronicles.filter((c) => c.measureType === TYPE_INDEX || c.event)
            const estimateChronicles = chronicles.filter((c) => c.measureType === TYPE_ESTIM)
            const readingCoefficient = variousMat?.counter?.readingCoefficient
            return (
                <Grid
                    key={chronicles[0].idMat}
                    container
                    direction='row'
                    justifyContent='center'
                    className={(isConsult || shared) ? '' : 'clickable'}
                >
                    <Element size={11} className='bold' container justifyContent='flex-start' alignItems='center'>
                        {variousMat.reference}{readingCoefficient ? ` - ${i18n.readingCoefficient} ${readingCoefficient}` : ''}
                        {variousMat?.counter?.informative && ` (${i18n.informative})`}
                        {shared && (
                            <Tooltip title={`${i18n.shared} (${contributorsIndex[variousMat.administrator]?.name})`}>
                                <People sx={{ marginLeft: 1 }} />
                            </Tooltip>
                        )}
                    </Element>
                    {getChroniclesByType(indexChronicles, TYPE_INDEX, variousMat, readingCoefficient, shared)}
                    {getChroniclesByType(estimateChronicles, TYPE_ESTIM, variousMat, 1, shared)}
                </Grid>
            )
        }
        return undefined
    }))

    const getEstimConso = (groupedChronicles) => {
        return groupedChronicles.map((chroniques) => {
            return chroniques.filter((c) => c.measureType === 1 && getCampaignYear(moment(c.measureDate), startDateCampaign) >= year).reduce((acc, c) => acc + c.value, 0) || 0
        }).reduce((acc, c) => acc + c, 0)
    }

    const getColorRealConso = (authorizedVolume) => {
        if (!hasValue(authorizedVolume) || !hasValue(realConso)) {
            return 'black'
        }
        if (realConso > authorizedVolume) {
            return 'red'
        }
        if (((realConso / authorizedVolume) * 100) >= 80) {
            return 'orange'
        }
        return 'green'
    }

    useEffect(() => {
        if (pointSelected) {
            const { startDate, endDate } = getCampaignPeriod(year, startDateCampaign)
            dispatch(AgriAction.calculPointVolumeReal(pointSelected.id, exploitation.idExploitation, startDate.valueOf(), endDate.valueOf())).then((res) => {
                setRealConso(res?.total)
                setLowWaterConso(res?.lowWater)
            })
        }
    }, [pointSelected, year, startDateCampaign])

    useEffect(() => {
        setDeclarationReal()
        const declRealYear = declarationsExploitation.find((d) => d.year === year + 1 && d.surveyType === SURVEY_TYPES.ANNUAL)
        if (declRealYear) {
            dispatch(AgriAction.fetchDeclaration(declRealYear.idDeclaration)).then((res) => res && setDeclarationReal(res))
        }
    }, [year])

    const usagesIrrigation = useMemo(() => usages.filter((u) => u.isCulture), [usages])

    const getContent = () => {
        const { pumpsIds, countersIds } = getMateriels(pointSelected.id)
        const pointVolumes = exploitationVolumes.filter((v) => v.idInstallation === pointSelected.id && v.askedYear === year) || []
        const chroniclesMat = exploitation.link_chronicles.filter(({ idMat }) => [...pumpsIds, ...countersIds].includes(idMat))
        const pointChronicles = chroniclesMat.filter(({ measureDate }) => getCampaignYear(moment(measureDate), startDateCampaign) === year &&
            (!pointSelected.startDate || measureDate >= pointSelected.startDate) &&
            (!pointSelected.endDate || measureDate < pointSelected.endDate),
        )
        const pointChroniclePrevYear = orderBy(chroniclesMat.filter(({ measureDate }) => getCampaignYear(moment(measureDate), startDateCampaign) === year - 1 &&
            (!pointSelected.startDate || measureDate >= pointSelected.startDate) &&
            (!pointSelected.endDate || measureDate < pointSelected.endDate),
        ), ['measureDate', 'endDate'], 'desc')
        const chroniclesToShow = pointChroniclePrevYear ? [...pointChronicles, ...pointChroniclePrevYear] : [...pointChronicles]
        const eventsMat = matEventsExploitation.filter(({ idMateriel }) => [...pumpsIds, ...countersIds].includes(idMateriel))
        const pointEvents = eventsMat.filter(({ eventDate }) => getCampaignYear(moment(eventDate), startDateCampaign) === year)
        const pointEventsFormatted = pointEvents.map((e) => {
            return {
                ...e,
                idMat: e.idMateriel,
                measureDate: e.eventDate,
                event: true,
            }
        })

        const groupedByMat = Object.values(groupBy([...chroniclesToShow, ...pointEventsFormatted], 'idMat'))
        const estimConso = groupedByMat.length ? getEstimConso(groupedByMat) : undefined
        const maxNumberOfValues = Math.max(...groupedByMat.map(({ length }) => length)) || 0

        const askedVolume = pointVolumes.filter((p) => hasValue(p.askedVolume)).length > 0 ? pointVolumes.reduce((acc, d) => acc + (d.askedVolume || 0), 0) : undefined
        const askedLowWaterVolume = pointVolumes.filter((p) => hasValue(p.askedLowWaterVolume)).length > 0 ? pointVolumes.reduce((acc, d) => acc + (d.askedLowWaterVolume || 0), 0) : undefined
        const attributedVolume = pointVolumes.filter((p) => hasValue(p.attributedVolume)).length > 0 ? pointVolumes.reduce((acc, d) => acc + (d.attributedVolume || 0), 0) : undefined
        const attributedLowWaterVolume = pointVolumes.filter((p) => hasValue(p.attributedLowWaterVolume)).length > 0 ? pointVolumes.reduce((acc, d) => acc + (d.attributedLowWaterVolume || 0), 0) : undefined
        const authorizedVolume = pointVolumes.filter((p) => hasValue(p.authorizedVolume)).length > 0 ? pointVolumes.reduce((acc, d) => acc + (d.authorizedVolume || 0), 0) : undefined
        const authorizedLowWaterVolume = pointVolumes.filter((p) => hasValue(p.authorizedLowWaterVolume)).length > 0 ? pointVolumes.reduce((acc, d) => acc + (d.authorizedLowWaterVolume || 0), 0) : undefined

        const pointUsages = (declaration.link_declarationInstallation.find((i) => i.idInstallation === pointSelected.id) || {}).link_usagesCurrent || []
        const irrigVolume = !declarationReal ? {} : pointUsages.filter((u) => usagesIrrigation.some(uI => uI.id === u.idUsage) && hasValue(u.requestedYearVolume)).reduce((acc, u) => {
            const total = (acc?.total ?? 0) + (u.requestedYearVolume ?? 0)
            const lowWater = (acc?.lowWater ?? 0) + (u.lowWaterVolume ?? 0)
            return {
                total,
                lowWater,
                notLowWater: total - lowWater,
            }
        }, {})
        const antiFreezeVolume = !declarationReal ? undefined : pointUsages
            .filter((u) => u.currentYear && u.idUsage === STATIC_USAGES_TYPES.ANTIFREEZE && hasValue(u.requestedYearVolume))
            .reduce((acc, u) => {
                const total = (acc?.total ?? 0) + (u.requestedYearVolume ?? 0)
                const lowWater = (acc?.lowWater ?? 0) + (u.lowWaterVolume ?? 0)
                return {
                    total,
                    lowWater,
                    notLowWater: total - lowWater,
                }
            }, {})
        const wateringVolume = !declarationReal ? undefined : pointUsages
            .filter((u) => u.currentYear && u.idUsage === STATIC_USAGES_TYPES.WATERING && hasValue(u.requestedYearVolume))
            .reduce((acc, u) => {
                const total = (acc?.total ?? 0) + (u.requestedYearVolume ?? 0)
                const lowWater = (acc?.lowWater ?? 0) + (u.lowWaterVolume ?? 0)
                return {
                    total,
                    lowWater,
                    notLowWater: total - lowWater,
                }
            }, {})
        const othersVolume = !declarationReal ? undefined : pointUsages
            .filter((u) => u.currentYear && ![STATIC_USAGES_TYPES.WATERING, STATIC_USAGES_TYPES.ANTIFREEZE, ...usagesIrrigation.map(uI => uI.id)].includes(u.idUsage) && hasValue(u.requestedYearVolume))
            .reduce((acc, u) => {
                const total = (acc?.total ?? 0) + (u.requestedYearVolume ?? 0)
                const lowWater = (acc?.lowWater ?? 0) + (u.lowWaterVolume ?? 0)
                return {
                    total,
                    lowWater,
                    notLowWater: total - lowWater,
                }
            }, {})
        return (
            <>
                <Grid
                    size={12}
                    container
                    direction='row'
                    justifyContent='space-between'
                    alignItems='center'
                    sx={{ padding: '0 8px' }}
                >
                    <Grid>
                        <Button
                            variant='contained'
                            color='secondary'
                            onClick={() => setYear(year - 1)}
                            sx={{ color: 'white' }}
                        >
                            <Icon>keyboard_arrow_left</Icon>
                            {year - 1}
                        </Button>
                    </Grid>
                    <Grid>
                        <h2>{year}</h2>
                    </Grid>
                    <Grid>
                        <Button
                            variant='contained'
                            color='secondary'
                            onClick={() => setYear(year + 1)}
                            sx={{ color: 'white' }}
                        >
                            {year + 1}
                            <Icon>keyboard_arrow_right</Icon>
                        </Button>
                    </Grid>
                </Grid>
                <Grid
                    size={12}
                    container
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    sx={{ padding: '8px' }}
                >
                    <Grid container justifyContent='space-around' size={12}>
                        <Element size={4} />
                        <Element size={2} className={classes.textLeft}>
                            {i18n.year} (m3)
                        </Element>
                        <Element size={2} className={classes.textLeft}>
                            {i18n.lowWater} (m3)
                        </Element>
                        <Element size={2} className={classes.textLeft}>
                            {i18n.notLowWater} (m3)
                        </Element>
                    </Grid>
                    <Grid container justifyContent='space-around' size={12}>
                        <Element size={4} className={classes.textLeft}>
                            {i18n.requestedVolume}
                        </Element>
                        <Element size={2} className={classes.textRight}>
                            {hasValue(askedVolume) ? formatMilliers(askedVolume) : '-'}
                        </Element>
                        <Element size={2} className={classes.textRight}>
                            {hasValue(askedLowWaterVolume) ? formatMilliers(askedLowWaterVolume) : '-'}
                        </Element>
                        <Element size={2} className={classes.textRight}>
                            {hasValue(askedVolume) && hasValue(askedLowWaterVolume) ? formatMilliers(askedVolume - askedLowWaterVolume) : '-'}
                        </Element>
                    </Grid>
                    <Grid container justifyContent='space-around' size={12}>
                        <Element size={4} className={classes.textLeft}>
                            {i18n.allocatedVolume}
                        </Element>
                        <Element size={2} className={classes.textRight}>
                            {hasValue(attributedVolume) ? formatMilliers(attributedVolume) : '-'}
                        </Element>
                        <Element size={2} className={classes.textRight}>
                            {hasValue(attributedLowWaterVolume) ? formatMilliers(attributedLowWaterVolume) : '-'}
                        </Element>
                        <Element size={2} className={classes.textRight}>
                            {hasValue(attributedVolume) && hasValue(attributedLowWaterVolume) ? formatMilliers(attributedVolume - attributedLowWaterVolume) : '-'}
                        </Element>
                    </Grid>
                    <Grid container justifyContent='space-around' size={12}>
                        <Element size={4} className={classes.textLeft}>
                            {i18n.authorizedVolume}
                        </Element>
                        <Element size={2} className={classes.textRight}>
                            {hasValue(authorizedVolume) ? formatMilliers(authorizedVolume) : '-'}
                        </Element>
                        <Element size={2} className={classes.textRight}>
                            {hasValue(authorizedLowWaterVolume) ? formatMilliers(authorizedLowWaterVolume) : '-'}
                        </Element>
                        <Element size={2} className={classes.textRight}>
                            {hasValue(authorizedVolume) && hasValue(authorizedLowWaterVolume) ? formatMilliers(authorizedVolume - authorizedLowWaterVolume) : '-'}
                        </Element>
                    </Grid>
                    <Grid container justifyContent='space-around' size={12}>
                        <Element size={4} className={classes.textLeft}>
                            {i18n.estimConsumption}
                        </Element>
                        <Element size={2} className={classes.textRight}>
                            {hasValue(estimConso) ? formatMilliers(estimConso) : '-'}
                        </Element>
                        <Element size={2} />
                        <Element size={2} />
                    </Grid>
                    <Grid container justifyContent='space-around' size={12}>
                        <Element size={4} className={classes.textLeft}>
                            {i18n.countedConsumption}
                        </Element>
                        <Element size={2} className={`${classes.textRight} bold`} sx={{ color: getColorRealConso(pointVolumes.authorizedVolume) }}>
                            {hasValue(realConso) ? formatMilliers(realConso) : '-'}
                        </Element>
                        <Element size={2} className={`${classes.textRight} bold`}>
                            {hasValue(lowWaterConso) ? formatMilliers(lowWaterConso) : '-'}
                        </Element>
                        <Element size={2} className={`${classes.textRight} bold`}>
                            {hasValue(realConso) && hasValue(lowWaterConso) ? formatMilliers(realConso - lowWaterConso) : '-'}
                        </Element>
                    </Grid>
                    <Grid container justifyContent='space-around' size={12}>
                        <Element size={4} className={classes.textLeft}>
                            {i18n.consoUseIrrig}
                        </Element>
                        <Element size={2} className={`${classes.textRight} bold`}>
                            {hasValue(irrigVolume?.total) ? formatMilliers(irrigVolume?.total) : '-'}
                        </Element>
                        <Element size={2} className={`${classes.textRight} bold`}>
                            {hasValue(irrigVolume?.lowWater) ? formatMilliers(irrigVolume?.lowWater) : '-'}
                        </Element>
                        <Element size={2} className={`${classes.textRight} bold`}>
                            {hasValue(irrigVolume?.notLowWater) ? formatMilliers(irrigVolume?.notLowWater) : '-'}
                        </Element>
                    </Grid>
                    <Grid container justifyContent='space-around' size={12}>
                        <Element size={4} className={classes.textLeft}>
                            {i18n.consoUseAntiFreeze}
                        </Element>
                        <Element size={2} className={`${classes.textRight} bold`}>
                            {hasValue(antiFreezeVolume?.total) ? formatMilliers(antiFreezeVolume?.total) : '-'}
                        </Element>
                        <Element size={2} className={`${classes.textRight} bold`}>
                            {hasValue(antiFreezeVolume?.lowWater) ? formatMilliers(antiFreezeVolume?.lowWater) : '-'}
                        </Element>
                        <Element size={2} className={`${classes.textRight} bold`}>
                            {hasValue(antiFreezeVolume?.notLowWater) ? formatMilliers(antiFreezeVolume?.notLowWater) : '-'}
                        </Element>
                    </Grid>
                    <Grid container justifyContent='space-around' size={12}>
                        <Element size={4} className={classes.textLeft}>
                            {i18n.consoUseWatering}
                        </Element>
                        <Element size={2} className={`${classes.textRight} bold`}>
                            {hasValue(wateringVolume?.total) ? formatMilliers(wateringVolume?.total) : '-'}
                        </Element>
                        <Element size={2} className={`${classes.textRight} bold`}>
                            {hasValue(wateringVolume?.lowWater) ? formatMilliers(wateringVolume?.lowWater) : '-'}
                        </Element>
                        <Element size={2} className={`${classes.textRight} bold`}>
                            {hasValue(wateringVolume?.notLowWater) ? formatMilliers(wateringVolume?.notLowWater) : '-'}
                        </Element>
                    </Grid>
                    <Grid container justifyContent='space-around' size={12}>
                        <Element size={4} className={classes.textLeft}>
                            {i18n.consoUseOthers}
                        </Element>
                        <Element size={2} className={`${classes.textRight} bold`}>
                            {hasValue(othersVolume?.total) ? formatMilliers(othersVolume?.total) : '-'}
                        </Element>
                        <Element size={2} className={`${classes.textRight} bold`}>
                            {hasValue(othersVolume?.lowWater) ? formatMilliers(othersVolume?.lowWater) : '-'}
                        </Element>
                        <Element size={2} className={`${classes.textRight} bold`}>
                            {hasValue(othersVolume?.notLowWater) ? formatMilliers(othersVolume?.notLowWater) : '-'}
                        </Element>
                    </Grid>
                    <Element className='bold' sx={{ padding: '8px', width: '100%' }}>{i18n.prelDetails}</Element>
                    {getChronicles(groupedByMat)}
                    <Grid>
                        <Button
                            variant='contained'
                            color='secondary'
                            onClick={() => setNumberOfLines(numberOfLines + 10)}
                            sx={{ marginTop: '10px', color: 'white' }}
                            disabled={numberOfLines > maxNumberOfValues}
                        >
                            {i18n.showMoreHistory}
                        </Button>
                    </Grid>
                </Grid>
            </>
        )
    }

    const getPointsList = (pointsList, title, options = {}) => {
        const { open, histo } = options
        const formatPointsList = orderBy(pointsList.map((p) => {
            return {
                ...p,
                cityName: (citiesIndex[p.townCode] || {})?.name,
            }
        }), ['townCode', 'cityName', 'parcel', 'section', 'code'])
        return (
            <Accordion defaultExpanded={open} className='margin-bottom-1'>
                <AccordionSummary>
                    <span className='bold'>{`${pointsList.length} ${title}`}</span>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: 0 }}>
                    {formatPointsList.map((p) => (
                        <GridItem
                            key={p.id}
                            className='clickable'
                            onClick={() => setPointSelected(p)}
                            sx={pointSelected?.id === p.id ? {
                                backgroundColor: 'rgba(22, 24, 50, 0.1)',
                            } : {}}
                        >
                            <Grid className='bold' container justifyContent='space-between'>
                                {p.cityName || ''}<span>{histo ? `${i18n.endDate} : ${getDate(p.endDate)}` : ''}</span>
                            </Grid>
                            <Grid>{p.location || ''}</Grid>
                            <Grid><b className='bold'>{p.code || ''}</b>{` ${`- ${p.parcel || ''} ${p.section || ''}${p.name ? ` - ${p.name}` : ''}`}`}</Grid>
                            <div className='padding-top-1'>
                                {getLastChronicle(p)}
                            </div>
                        </GridItem>
                    ))}
                </AccordionDetails>
            </Accordion>

        )
    }
    const onCancelIndex = () => {
        setParamsModalConso({ selectedMaterial: undefined, consoType: undefined, open: false })
    }

    const onSaveChronicles = (link_chronicles) => {
        const updateExploitation = {
            ...exploitation,
            link_chronicles,
        }
        setParamsModalConso({ selectedMaterial: undefined, consoType: undefined, open: false })
        dispatch(AgriAction.updateExploitation(updateExploitation,
            () => dispatch(AgriAction.fetchExploitation(exploitationId)),
        ))
    }

    const getConsoModal = () => {
        if (paramsModalConso.open) {
            const { pumpsIds, countersIds, materiels } = getMateriels(pointSelected.id)
            const exploitationMatIds = materiels.map(m => m.id)
            return (
                <AddConsoModal
                    open={paramsModalConso.open}
                    point={pointSelected}
                    pumpsIds={uniq(pumpsIds.filter((iden) => exploitationMatIds.includes(iden)))}
                    countersIds={uniq(countersIds.filter((iden) => exploitationMatIds.includes(iden)))}
                    selectedMaterial={paramsModalConso.selectedMaterial}
                    consoType={paramsModalConso.consoType}
                    onSave={onSaveChronicles}
                    onCancel={onCancelIndex}
                    chronicles={exploitation.link_chronicles}
                    entrySettings={entrySettings}
                />
            )
        }
        return undefined
    }

    const onCancelEvent = () => {
        setOpenModalEvent(false)
        setSelectedEvent(undefined)
    }

    const onValidateEvent = (event) => {
        onCancelEvent()
        if (event.id) {
            dispatch(VariousMaterielAction.updateMatEvent(event,
                () => dispatch(VariousMaterielAction.fetchMatEventsByExploitation(exploitationId)),
            ))
        } else {
            dispatch(VariousMaterielAction.createMatEvent(event,
                () => dispatch(VariousMaterielAction.fetchMatEventsByExploitation(exploitationId)),
            ))
        }
    }

    const onDeleteEvent = (event) => {
        onCancelEvent()
        dispatch(VariousMaterielAction.deleteMatEvent(event.id,
            () => dispatch(VariousMaterielAction.fetchMatEventsByExploitation(exploitationId)),
        ))
    }

    return (
        <>
            <Grid container spacing={1}>
                <Grid size={4}>
                    {getPointsList(pointsUsed, getI18nTitleData(i18n.usedPoint, i18n.usedPoints, pointsUsed), { open: true })}
                    {getPointsList(pointsNotUsed, getI18nTitleData(i18n.noUsedPoint, i18n.noUsedPoints, pointsNotUsed))}
                    {getPointsList(pointsAbandonned, getI18nTitleData(i18n.deletePoint, i18n.deletePoints, pointsAbandonned))}
                    {getPointsList(exploitationPointsHisto, getI18nTitleData(i18n.pointPrelevementHisto, i18n.pointsPrelevementHisto, exploitationPointsHisto), { histo: true })}
                </Grid>
                <Grid size={4}>
                    <Card
                        title={pointSelected ? `${i18n.consos} - ${i18n.point} ${pointSelected.code}` : i18n.noPointSelected}
                        actions={pointSelected && !pointSelected.histo && !isConsult ? [
                            { onClick: () => setParamsModalConso({ open: true }), iconName: 'edit', tooltip: i18n.change },
                            { onClick: () => setOpenModalEvent(true), iconName: 'warning', tooltip: i18n.reportFailure },
                        ] : []}
                        round
                        cardStyle={{ position: 'sticky' }}
                    >
                        <Grid container alignItems='center'>
                            {pointSelected && getContent()}
                        </Grid>
                    </Card>
                </Grid>
                <Grid size={4}>
                    <EvolVolumesChartPanel statistics={uniqWith(exploitation.link_conso_real.map(c => omit(c, 'idInstallation')), (a, b) => a.idMat === b.idMat && a.year === b.year && a.volume === b.volume)} />
                    <div className='margin-top-1'>
                        <CartographyPanel
                            layers={['STATIONS_POINTS']}
                            satelliteMode
                            noMarkerTooltip
                            noSearchBar
                            componentType='all'
                            fullScreenable
                            stationsPoints={exploitationPoints || []}
                            height={300}
                            noStationPanel
                            noPanels
                        />
                    </div>
                </Grid>
            </Grid>
            {paramsModalConso.open && getConsoModal()}
            {openModalEvent && (
                <MatEventModal
                    open={openModalEvent}
                    defaultEvent={selectedEvent}
                    materiels={getMateriels(pointSelected.id).materiels}
                    onCancel={onCancelEvent}
                    onValidate={onValidateEvent}
                    onDelete={onDeleteEvent}
                />
            )}
        </>
    )
}

ExploitationConsumptionsApp.propTypes = {
    params: PropTypes.shape({
        id: PropTypes.string,
    }),
}

export default ExploitationConsumptionsApp